import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserRole } from '@core/models/admin/user-role';
import { firstValueFrom } from 'rxjs';
import { AnalyticReport } from '../models/admin/analytic-report';
import { ApicService } from './apic.services';
import { ConfigService } from './config.service';

@Injectable()
export class AdminService {
  basePath = `${this.apicService.apiPath}${this.configService.appConfig.api.baseUrl}/admin`

  constructor(private configService: ConfigService, private httpClient: HttpClient, private apicService: ApicService) { }

  getUserRoles(): Promise<UserRole[]> {
    return firstValueFrom(this.httpClient.get<UserRole[]>(`${this.basePath}/roleList`));
  }

  getAnalyticReports(): Promise<AnalyticReport[]> {
    return firstValueFrom(this.httpClient.get<AnalyticReport[]>(`${this.basePath}/analyticReports`));
  }

}
